import app from '../../app';
import projectsModel from '$$projectModel';
import { api } from '$$store/api';
import helpers from './helpers';
import filterHelpers from '../../views/filter/helpers';
import filterConstants from '../../views/filter/constants';

export default {
  async loadData({ dispatch }) {
    if (!app.config.mode.isBase && (app.config.mode.isLink || (app.config.mode.isExport && app.config.mode.ignoreFilters))) {
      app.checkInit('filters');
    } else {
      await Promise.all([
        projectsModel.waitData,
        await dispatch('fetchSavedFilters'),
        await dispatch('fetchActiveFilters'),
      ]);
      app.checkInit('filters');
      // app.trigger('filters:init');
    }
  },
  async fetchSavedFilters({ commit }) {
    const response = await api.get('/filters');

    // console.log('SAVED FILTERS ----------------->', helpers.groupSavedFilters(response.data));
    commit('setSavedFilters', helpers.groupSavedFilters(response.data));
  },
  async fetchActiveFilters({ commit }) {
    const response = await api.get('/filters/active');
    const filters = response.data;

    // console.log('ACTIVE FILTERS ----------------->', filters);
    commit('setActiveFilters', filters);
  },
  async updateActiveFilter({ getters, commit }, payload) {
    const currentFilter = getters.currentFilter;
    // const activeFilters = getters.activeFilters;

    const filterType = payload?.type || currentFilter.type;
    // const filterProperties = payload?.properties || currentFilter.properties;
    const filterProperties = {
      ...currentFilter?.properties,
      ...payload?.properties,
    };

    const updatedData = {
      type: filterType,
      filter: filterProperties,
      project_id: currentFilter?.project_id,
      multiview_id: currentFilter?.multiview_id,
    };

    const response = await api.post('filters/active', updatedData);

    console.log('ACTIVE FILTERS ----------------->', response.data);
    commit('setActiveFilters', response.data);

    // if (!activeFilters[filterType]) {
    //   let newFilter = res.data;

    //   if (filterType === 'list') {
    //     newFilter = { common: res.data };
    //   }

    //   const updatedFilters = {
    //     ...activeFilters,
    //     [filterType]: newFilter,
    //   };

    //   commit('setActiveFilters', updatedFilters);
    // } else {
    //   commit('updateActiveFilter', updatedData);
    // }
  },
  async saveFilter({ commit, getters }, name) {
    const currentFilter = getters.currentFilter;

    const updatedData = {
      name,
      type: currentFilter.type,
      filter: currentFilter.properties,
      project_id: currentFilter.project_id,
      multiview_id: currentFilter.multiview_id,
    };

    const response = await api.post('/filters/add', updatedData);

    commit('addSavedFilter', response.data);
    commit('updateCurrentFilter', { id: response.data.id, name, properties: response.data.filter });
  },
  async removeFilter({ commit }, payload) {
    await api.delete(`filters/${payload.filterId}`);
    commit('removeSavedFilterByIdAndType', payload);
  },
  async updateFilterName({ commit }, payload) {
    await api.put(`filters/${payload.id}`, { name: payload.name });

    commit('updateFilterName', payload);
  },
  async resetFilter({ getters, dispatch, commit }) {
    const currentFilter = getters.currentFilter;

    const emptyProperties = filterHelpers.getEmptyFilter();

    commit('updateCurrentFilter', { id: null, name: null, properties: emptyProperties });
    if (currentFilter.type !== filterConstants.FILTERS.history && !getters.isExport) {
      await dispatch('updateActiveFilter');
    }
  },
};
